<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./ModernTechnologicalInfrastructure.translations.json";
	import video from "../assets/videos/brano-about-our-technologies.mp4";
	import videoMobile from "../assets/videos/brano-about-our-technologies-mobile.mp4";
	import StaticVideo from "./Video/StaticVideo.svelte";
	import Link from "./Link.svelte";
	import { technologyPathMap } from "../../../core/schema/paths/technologyPathMap.js";
	import { getPathInLocale } from "../../../core/schema/paths/getPathInLocale.js";
	import { getTenant } from "../contexts/tenantContextKey.js";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import point1Image from "../assets/images/digitalized.png?webp&h=580&imagetools";
	import point2Image from "../assets/images/storagesystems.png?webp&h=580&imagetools";
	import point3Image from "../assets/images/process.png?webp&h=580&imagetools";
	import { nbspifyHtml } from "../../../core/utils/nbspifyHtml.js";

	const translate = getTranslate(translations);
	const { locale } = getTenant();

	const points = [
		{
			text: translate("point1"),
			image: point1Image,
		},
		{
			text: translate("point2"),
			image: point2Image,
		},
		{
			text: translate("point3"),
			image: point3Image,
		},
	];

	/* eslint-disable svelte/no-at-html-tags */
</script>

<section class="relative mt-5 min-h-screen lg:mt-44">
	<StaticVideo class="!absolute inset-0 -z-10 lg:hidden" videoClass="w-full h-full object-cover" video={videoMobile} />
	<StaticVideo class="!absolute inset-0 -z-10 hidden lg:block" videoClass="w-full h-full object-cover" {video} />
	<div
		class="container flex min-h-[inherit] flex-col justify-end pb-4 lg:flex-row lg:items-start lg:justify-between lg:py-16 lg:pb-36"
	>
		<div class="bg-white px-8 py-10 lg:max-w-[50%] lg:p-14">
			<h2 class="text-[2rem] font-semibold lg:text-4xl">{translate("headline")}</h2>
			<p class="lg:text-2md text-[1.125rem] font-normal lg:font-light">{translate("content")}</p>
		</div>
		<Link asButton containerClass="!w-fit" class="hidden lg:flex" href="/{getPathInLocale(locale, technologyPathMap)}">
			{translate("exploreMore")}
		</Link>
	</div>
</section>

<section class="relative grid grid-rows-3 sm:container lg:-top-36 lg:grid-cols-3 lg:grid-rows-1">
	{#each points as point}
		<div class="group relative flex aspect-square w-full flex-col justify-end p-12 lg:h-full lg:w-auto lg:p-16">
			<StaticPicture
				image={point.image}
				width={580}
				height={580}
				alt={point.text}
				class="absolute inset-0 -z-10"
				imgClass="h-full w-full object-cover"
			/>
			<div class="absolute inset-0 -z-10 bg-[#313135BF] transition-colors group-hover:bg-transparent"></div>
			<span class="text-2md xl:text-2lg leading-tight text-white">{@html nbspifyHtml(point.text)}</span>
		</div>
	{/each}
</section>

<Link
	asButton
	containerClass="mt-5 container justify-center flex"
	class="lg:hidden"
	href="/{getPathInLocale(locale, technologyPathMap)}"
>
	{translate("exploreMore")}
</Link>
